// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import BlogsCreatePage from './blogs-create-page';
// assets
//

// ----------------------------------------------------------------------

export default function Createblogs() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <BlogsCreatePage />
        </Container >
    );
}
